import axios from "axios";
import * as utils from "./utils";
import { Reset } from "./dispatch";
import { getActiveRole, getDecryptedToken, getDecryptedUserData } from "./bycrypt";
import { TrueTimeService } from "./timeUtils";

const API_URL = utils.API_URL;
const axiosInstance = axios.create({
  baseURL: API_URL, // Set the base URL here
});

const controllers: Record<string, AbortController> = {};

export const getActiveRoleId = () => {
  try {
    const savedDefaultRoleStr = localStorage.getItem("default_role");
    if (savedDefaultRoleStr) {
      const savedRole = JSON.parse(savedDefaultRoleStr);
      if (savedRole?._id) return savedRole._id;
      if (typeof savedRole === "string") return savedRole;
    }
  } catch (e) {}

  try {
    const userData = getDecryptedUserData();
    const activeRole = getActiveRole(userData?.role);
    if (activeRole?._id) return activeRole._id;
    if (typeof activeRole === "string") return activeRole;
  } catch (e) {}

  return "";
};

// axios interceptor request to setup token in header
axiosInstance.interceptors.request.use(async (config: any) => {
  const AuthToken = getDecryptedToken();
  const activeRoleId = getActiveRoleId();
  config.baseURL = API_URL;

  // const requestKey = `${config.method}-${config.url}`;
  // if (controllers[requestKey]) {
  //   controllers[requestKey].abort(); // cancel previous same request
  // }
  // const controller = new AbortController();
  // controllers[requestKey] = controller;
  // config.signal = controller.signal;

  config.headers = {
    ...config.headers,
    "Api-Key": utils?.API_KEY ? utils?.API_KEY : "",
    Accept: "application/json",
    // Authorization: `Bearer ${AuthToken}`,
    // "X-Requested-With": "XMLHttpRequest",
    "Accept-Language": "en",
    "Access-Control-Allow-Origin": "*",
  };

  if (AuthToken) {
    config.headers.Authorization = `Bearer ${AuthToken}`;
  }

  if (activeRoleId) {
    config.headers["active-role"] = activeRoleId;
    config.headers["Active-Role"] = activeRoleId;
  }
  return config;
});

//axios interceptor response to set auto logout
axiosInstance.interceptors.response.use(
  (response) => {
    const requestKey = `${response.config.method}-${response.config.url}`;
    delete controllers[requestKey];
    
    // Initialize TrueTimeService from server Date header if available
    if (response.headers && response.headers.date) {
      TrueTimeService.initialize(response.headers.date);
    }
    
    return response;
  },
  (error) => {
    if (error?.config) {
      const requestKey = `${error.config.method}-${error.config.url}`;
      delete controllers[requestKey];
    }
    if (error?.name === "AbortError") {
      return Promise.reject(error);
    }
    if (error?.code === "ERR_CANCELED") {
      return Promise.reject(error);
    }
    if (error.message === "Network Error") {
      error.response = {
        status: 500,
        data: {
          message: "Network Error | Network Unavailable",
        },
      };
    }
    if (error.response.status === 444) {
      let errMsg = error?.response?.data?.msg
        ? error?.response?.data?.msg
        : error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : "Unauthorized";

      error.response = {
        status: 444,
        data: {
          message: errMsg,
        },
      };
      Reset();
    }
    if (error.response.status === 500) {
      if (!error.response.data || !error.response.data.message) {
        error.response = {
          status: 500,
          data: {
            message: "Something went wrong",
          },
        };
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
